import { isValidDate } from '../GeneralValidators';
import { getAgeFromCNP } from '../../general/Utilities';
export var AmountZeroField = function AmountZeroField(value) {
  if (value == '') {
    return {
      status: false,
      msg: 'Completează câmpul'
    };
  } else if (isNaN(value)) {
    return {
      status: false,
      msg: 'Completează doar cifre'
    };
  } else if (value < 0) {
    return {
      status: false,
      msg: 'Completeaza o sumă pozitivă'
    };
  } else {
    return {
      status: true,
      msg: ''
    };
  }
};
export var ValidDate = function ValidDate(value, param) {
  var minAge = param.minAge,
      maxAge = param.maxAge;

  if (value == '') {
    return {
      status: false,
      msg: 'Completează câmpul'
    };
  }

  var validData = isValidDate(value);

  if (!validData) {
    return {
      status: false,
      msg: 'Dată invalidă'
    };
  }

  var day = validData.day,
      month = validData.month,
      year = validData.year;

  if (minAge || maxAge) {
    var currentDate = new Date();
    var birthDate = new Date(year, month - 1, day);

    if (currentDate < birthDate) {
      return {
        status: false,
        msg: 'Ai venit din viitor?'
      };
    }

    var ageDate = new Date(new Date() - new Date(year, month - 1, day)); // miliseconds from epoch

    var years = Math.abs(ageDate.getUTCFullYear() - 1970);

    if (minAge) {
      if (years < minAge) {
        return {
          status: false,
          msg: 'Vârsta minimă este de ' + minAge + ' ani'
        };
      }
    }

    if (maxAge) {
      if (years > maxAge) {
        return {
          status: false,
          msg: 'Vârsta maximă este de ' + maxAge + ' ani'
        };
      }
    }
  }

  return {
    status: true,
    msg: ''
  };
};
export var validateEligibilityData = function validateEligibilityData(profile) {
  if (!profile.hasOwnProperty('income') || !Number.isInteger(profile.income) || profile.income <= 0) {
    return false;
  }

  if (!profile.hasOwnProperty('totalEmployment') || !Number.isInteger(profile.totalEmployment) || profile.totalEmployment < 0) {
    return false;
  }

  if (!profile.hasOwnProperty('currentEmployment') || !Number.isInteger(profile.currentEmployment) || profile.currentEmployment < 0) {
    return false;
  }

  if (!profile.hasOwnProperty('age') || !Number.isInteger(profile.age) || profile.age < 18 || profile.age > 100) {
    return false;
  }

  if (!profile.hasOwnProperty('currentPayments') || !Number.isInteger(profile.currentPayments) || profile.currentPayments < 0) {
    return false;
  }

  if (!profile.hasOwnProperty('birthdate') || !isValidDate(profile.birthdate)) {
    return false;
  }

  return true;
};
export var AmountOptionalField = function AmountOptionalField(value) {
  if (value == '') {
    return {
      status: true,
      msg: ''
    };
  } else if (isNaN(value)) {
    return {
      status: false,
      msg: 'Completează doar cifre'
    };
  } else if (value <= 0) {
    return {
      status: false,
      msg: 'Completeaza o sumă pozitivă'
    };
  } else {
    return {
      status: true,
      msg: ''
    };
  }
};
export var isInvalidCNP = function isInvalidCNP(value) {
  if (value.length != 13) {
    return 'CNP trebuie sa aiba 13 cifre';
  }

  var suma = 0;
  var sirdeverif = new Array();
  sirdeverif[0] = 2;
  sirdeverif[1] = 7;
  sirdeverif[2] = 9;
  sirdeverif[3] = 1;
  sirdeverif[4] = 4;
  sirdeverif[5] = 6;
  sirdeverif[6] = 3;
  sirdeverif[7] = 5;
  sirdeverif[8] = 8;
  sirdeverif[9] = 2;
  sirdeverif[10] = 7;
  sirdeverif[11] = 9;
  var anum = /(^\d+$)|(^\d+\.\d+$)/;
  var testresult;

  if (anum.test(value)) {
    testresult = true;

    for (var i = 0; i < sirdeverif.length; i++) {
      suma = suma + value.substring(i, i + 1) * sirdeverif[i];
    }

    suma = suma % 11;
    var an = parseInt(value.substring(1, 3));
    var sex = parseInt(value.substring(0, 1));

    switch (sex) {
      case 1:
      case 2:
        {
          an += 1900;
        }
        break;

      case 3:
      case 4:
        {
          an += 1800;
        }
        break;

      case 5:
      case 6:
        {
          an += 2000;
        }
        break;

      case 7:
      case 8:
      case 9:
        {
          an += 2000;

          if (an > parseInt(new Date().getYear(), 10) - 14) {
            an -= 100;
          }
        }
        break;

      default:
        {
          return 'CNP incorect';
        }
    }

    if (suma == value.substring(12, 13) || suma / 10 == value.substring(12, 13)) {
      testresult = true;
    } else {
      return 'CNP incorect';
    }
  } else {
    return 'CNP incorect';
  }

  return false;
};
export var CNPFieldValidator = function CNPFieldValidator(value) {
  var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    minAge: null,
    maxAge: null,
    provider: null
  };
  var minAge = param.minAge,
      maxAge = param.maxAge,
      provider = param.provider;
  var error = isInvalidCNP(value);

  if (error) {
    return {
      status: false,
      msg: error
    };
  }

  var age = getAgeFromCNP(value);

  if (provider) {
    switch (provider) {
      case 'Telekom Banking':
        if (age < 22) {
          return {
            status: false,
            msg: "V\xE2rsta minim\u0103 este 22 ani"
          };
        }

    }
  }

  if (minAge || maxAge) {
    if (minAge && age < minAge) {
      return {
        status: false,
        msg: "V\xE2rsta minim\u0103 este ".concat(minAge, " ani")
      };
    }

    if (maxAge && age > maxAge) {
      return {
        status: false,
        msg: "V\xE2rsta maxim\u0103 este ".concat(maxAge, " ani")
      };
    }
  }

  return {
    status: true,
    msg: ''
  };
};
export var isInvalidCIF = function isInvalidCIF(value) {
  var cif;

  if (value.substring(0, 2).toUpperCase() == 'RO') {
    if (value.length > 12 || value.length < 4) {
      return 'CIF invalid';
    }

    cif = value.substring(2);
  } else {
    if (value.length > 10 || value.length < 2) {
      return 'CIF invalid';
    }

    cif = value;
  }

  if (isNaN(cif)) {
    return 'CIF invalid';
  }

  var testKey = '753217532';
  var reverseKey = testKey.split('').reverse().join('');
  var reverseCif = cif.split('').reverse().join('');
  var sum = 0;

  for (var i = 1; i < reverseCif.length; i++) {
    sum += parseInt(reverseCif[i]) * parseInt(reverseKey[i - 1]);
  }

  var check = sum * 10 % 11;
  if (check == 10) check = 0;

  if (check == reverseCif[0]) {
    return false;
  }

  return 'CIF invalid';
};
export var CIFFieldValidator = function CIFFieldValidator(value) {
  if (value == '') {
    return {
      status: false,
      msg: 'Completează cămpul'
    };
  }

  var error = isInvalidCIF(value);

  if (error) {
    return {
      status: false,
      msg: error
    };
  }

  return {
    status: true,
    msg: ''
  };
};